import { render, staticRenderFns } from "./ModalSubirMultipleDocumentos.vue?vue&type=template&id=5a740d21&"
import script from "./ModalSubirMultipleDocumentos.vue?vue&type=script&lang=js&"
export * from "./ModalSubirMultipleDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubirMultipleDocumentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports